// extracted by mini-css-extract-plugin
module.exports = {"empty-message":"WhatsNewList_empty-message__RgkUp","list":"WhatsNewList_list__msqyk","item":"WhatsNewList_item___i1uW"};